import "./Skills.scss";
import Title from "../../../../components/Title/Title";
import {
  SiHtml5,
  SiCss3,
  SiBootstrap,
  SiTailwindcss,
  SiJavascript,
  SiTypescript,
  SiReact,
  SiNextdotjs,
  SiRedux,
  SiNodedotjs,
  SiSupabase,
  SiSanity,
  SiMongodb,
  SiShadcnui,
} from "react-icons/si";
import { FaStripeS } from "react-icons/fa";
import { GiBearHead } from "react-icons/gi";

const Skills = () => {
  const skills = [
    { name: "HTML5", icon: <SiHtml5 />, color: "#00adb5" },
    { name: "CSS/SCSS", icon: <SiCss3 />, color: "#00adb5" },
    { name: "Bootstrap", icon: <SiBootstrap />, color: "#00adb5" },
    { name: "Tailwind", icon: <SiTailwindcss />, color: "#00adb5" },
    { name: "ShadCN", icon: <SiShadcnui />, color: "#00adb5" },
    { name: "Javascript", icon: <SiJavascript />, color: "#00adb5" },
    { name: "Typescript", icon: <SiTypescript />, color: "#00adb5" },
    { name: "ReactJS", icon: <SiReact />, color: "#00adb5" },
    { name: "NextJS", icon: <SiNextdotjs />, color: "#00adb5" },
    { name: "Redux", icon: <SiRedux />, color: "#00adb5" },
    { name: "Zustand", icon: <GiBearHead />, color: "#00adb5" },
    { name: "NodeJS/Express", icon: <SiNodedotjs />, color: "#00adb5" },
    { name: "Stripe", icon: <FaStripeS />, color: "#00adb5" },
    { name: "Sanity CMS", icon: <SiSanity />, color: "#00adb5" },
    { name: "Mongo", icon: <SiMongodb />, color: "#00adb5" },
    { name: "Supabase", icon: <SiSupabase />, color: "#00adb5" },
  ];

  return (
    <div className="page-container skills">
      <Title heading={"Skills"} />
      <div className="skills-grid">
        {skills.map((skill, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-duration={500 + index * 100}
            className="skill-icon-item"
          >
            <div className="icon-wrapper" style={{ color: skill.color }}>
              {skill.icon}
            </div>
            <span className="skill-label">{skill.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
